import React from 'react';
import { Redirect } from 'react-router';
import { IonSpinner, IonContent, IonPage } from '@ionic/react';
import { useHasSeenTutorial } from '../hooks/useTutorial';
import { getAppConfig } from '../config/app.config';

/**
 * Componente que decide si mostrar el tutorial o ir directamente a la aplicación
 * Usa el nuevo hook useTutorial para verificar el estado
 */
const HomeOrTutorial: React.FC = () => {
  const { hasSeenTutorial, isLoading } = useHasSeenTutorial();

  // Mostrar spinner mientras se carga el estado del tutorial
  if (isLoading) {
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
            <IonSpinner name="crescent" />
          </div>
        </IonContent>
      </IonPage>
    );
  }

  // Redirigir según el estado del tutorial
  const defaultRoute = getAppConfig().auth.defaultRoute || '/tabs/schedule';
  return hasSeenTutorial ? <Redirect to={defaultRoute} /> : <Redirect to="/tutorial" />;
};

export default HomeOrTutorial;